import React from 'react';
import PlayArrowTwoToneIcon from '@mui/icons-material/PlayArrowTwoTone';
import { MediaItemValue } from '@fulcrumapp/fulcrum-core';
import MediaThumbnail from './media-thumbnail';

type Props = {
  item: MediaItemValue;
  styles: React.CSSProperties;
  handleClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const VideoThumbnail = ({ item, styles, handleClick }: Props) => (
  <MediaThumbnail
    styles={styles}
    item={item}
    handleClick={handleClick}
    data-testid="video-thumbnail"
  >
    <PlayArrowTwoToneIcon
      sx={{
        position: 'absolute',
        top: '35%',
        right: '34%',
        opacity: 0.75,
        backgroundColor: '#fff',
      }}
      data-testid="video-play-icon"
    />

  </MediaThumbnail>
);

export default VideoThumbnail;
